import PostFilter from './components/post-filter';

export default PostFilter;
